import axios from 'axios'
import { useMutation, useQueryClient } from 'react-query'

export const useSponsorsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (body: any) => {
      return axios.put(`/sponsor`, body)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['sponsors'])
      }
    }
  )
}
